__turbopack_context__.v({
  "hint": "GenericCheckboxList-module-scss-module__xgCcZq__hint",
  "label": "GenericCheckboxList-module-scss-module__xgCcZq__label",
  "list": "GenericCheckboxList-module-scss-module__xgCcZq__list",
});
